<div class="market-history">
  <ul class="nav nav-pills" role="tablist">
    <i class="ion-md-link text-muted mx-2 align-self-center" style="font-size: 20px; vertical-align: middle;" *ngIf="!reuters"></i>

    <li class="nav-item">
      <a class="nav-link active text-center" data-toggle="pill" (click)="setNewsView(true)" role="tab" aria-selected="true">
        <h6>{{"news"|translate}}</h6>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="pill" (click)="setNewsView(false)" role="tab" aria-selected="false">
        <h6>{{"announcements"|translate}}</h6>
      </a>
    </li>
    <span class="widget-reuters" matTooltipPosition="left" matTooltipClass="custom-tooltip" [matTooltip]='companyName' *ngIf="reuters != null">
      {{reuters}}
    </span>
  </ul>

  <div class="custom-news-container">
    <div class="row no-data m-0" *ngIf="!companyNews && !isNewsLoading">
      <div class="col-md-12">
        <img class="empty-state" src="/assets/img/noData.png" />
        <div class="col-sm-12">
          <h6 class="nodata-msg"> {{"select-company-hint"|translate}} </h6>
        </div>
      </div>
    </div>
    <div class="row no-data m-0" *ngIf="companyNews && companyNews.length == 0 && !isNewsLoading && isNewsView">
      <div class="col-md-12">
        <img class="empty-state" src="/assets/img/noData.png" />
        <div class="col-sm-12">
          <h6 class="nodata-msg"> {{'no-news-hint'|translate}} </h6>
        </div>
      </div>
    </div>
    <div class="row no-data m-0" *ngIf="announcements && announcements.length == 0 && !isNewsLoading && !isNewsView">
      <div class="col-md-12">
        <img class="empty-state" src="/assets/img/noData.png" />
        <div class="col-sm-12">
          <h6 class="nodata-msg"> {{'no-news-hint'|translate}} </h6>
        </div>
      </div>
    </div>
    <tbody class="d-flex justify-content-center" *ngIf="isNewsLoading">
      <div class="spinner-border  text-secondary m-5" role="status">
        <span class="sr-only"></span>
      </div>
    </tbody>
    <div *ngIf="!isNewsLoading && isNewsView && companyNews.length>0" style="height: 100% !important;">
      <ul>
        <li class="news-card-bg" *ngFor="let item of companyNews"><a (click)="openNewsModal(item)" style="text-align: start;">
            <div style="font-size: 14px; font-weight: 500;">
              {{(translate.currentLang=='en')?item.HEADING:item.ARB_HEADING}}
            </div>
            {{item.SHORT_DESC}}
            <div class="d-flex justify-content-between mt-2">
              <span>
                {{item.DATE_STAMP}}
              </span>
              <span class="news-type-badge rounded-pill" [ngStyle]="getColor(item.SEC_ID)">
                {{(translate.currentLang=='en')?item.SECTION:item.SECTION_ARB}}
              </span>
            </div>
          </a></li>
      </ul>
    </div>
    <div *ngIf="!isNewsLoading && !isNewsView && announcements.length>0" style="height: 100% !important;">
      <ul>
        <li class="news-card-bg" *ngFor="let item of announcements"><a (click)="openNewsModal(item)" style="text-align: start;">
            <div style="font-size: 14px; font-weight: 500;">
              {{(translate.currentLang=='en')?item.HEADING:item.ARB_HEADING}}</div>
            {{item.SHORT_DESC}}
            <span>{{item.DATE_STAMP}}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
